import { render, staticRenderFns } from "./tickets-index.vue?vue&type=template&id=2df4f7f3&"
import script from "./tickets-index.vue?vue&type=script&lang=js&"
export * from "./tickets-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports